import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

//home

// SWITCH
if (document.querySelector('.home__switch')) {
  let body = document.querySelector('body')
  let homeSwitch = document.querySelector('.home__switch');
  let homeSwitchStories = document.querySelector('.home__switch-right');
  let homeSwitchFaces = document.querySelector('.home__switch-left');

  // init 
  body.classList.add('home--faces-active');
  homeSwitch.classList.add('home--switch-faces-active');

  homeSwitchStories.addEventListener('click', (e)=>{
    e.preventDefault();
    body.classList.add('home--faces-active');
    body.classList.remove('home--stories-active');
    homeSwitch.classList.add('home--switch-faces-active');
    homeSwitch.classList.remove('home--switch-stories-active');
  });
  
  homeSwitchFaces.addEventListener('click', (e)=>{
    e.preventDefault();
    body.classList.remove('home--faces-active');
    body.classList.add('home--stories-active');
    homeSwitch.classList.remove('home--switch-faces-active');
    homeSwitch.classList.add('home--switch-stories-active');
  });

  homeSwitch.addEventListener('click', (e)=>{
    e.preventDefault();
    if body.classList.contains('home--faces-active') {
      homeSwitch.classList.remove('home--switch-faces-active');
      homeSwitch.classList.add('home--switch-stories-active');
      body.classList.remove('home--faces-active');
      body.classList.add('home--stories-active');
    } else {
      body.classList.remove('home--stories-active');
      body.classList.add('home--faces-active');
      homeSwitch.classList.add('home--switch-faces-active');
      homeSwitch.classList.remove('home--switch-stories-active');
    }
  });

  
}


if (document.querySelector('.home__overlay')) {
  let homeOverlay = '.home__overlay'
  let homeTimeline = gsap.timeline();

  homeTimeline
    .to(".cover-left", 1, { scaleX: 0, transformOrigin: "left" })
    .to(".cover-right", 1, { scaleX: 0, transformOrigin: "right" }, "-=1")
    .from(".img-left", 1 {scale: 1.2}, "-=1")
    .from(".img-right", 1 {scale: 1.2}, "-=1")

    // .from(".home__relief path", {scale: 0, ease: "none", transformOrigin: "center", stagger: 0.02})
    // .from(".home__relief", {opacity: 0})
    .from(".title", 1.5, { y: -50 }, "-=1")
    .from(".title-number", 1.5, { y: 200 }, "-=1.5")
    .from(".img-left", 1 {x: -25})
    .from(".img-right", 1 {x: 25}, "-=1")
    .from(".home__overlay__content__buttons", 1 {y: 50, opacity: 0}, "-=1");

}

